import { getTimezoneOffsetMinutes } from '../utils/date/date-utils-yyyy-mm-dd'
import { MINUTES_IN_HOUR, USA_TIMEZONE } from './date'

const SCHEDULED_ORDER_FORMAT_TIME = 'hhA'
const ROUTE_OPTIMIZATION_HOUR_INDIANA_INDIANAPOLIS = 14 // 2:00 PM South Bend time

/**
 * This needs to be a function because the offset may change due to Daylight
 * Saving Time without a release/deployment.
 */
function getRouteOptimizationHourUtc() {
  //we have to ceil here because the offset will be a fractional hour
  //and negative (e.g., -4.5), so flooring would give -5 instead of -4
  const utcOffsetHours = Math.ceil(
    getTimezoneOffsetMinutes(new Date(), USA_TIMEZONE.INDIANA_INDIANAPOLIS) /
      MINUTES_IN_HOUR,
  )
  //we subtract the offset to get to the UTC hour
  //tzTime - offset = tzTime - (tzTime - utcTime) = tzTime - tzTime + utcTime = utcTime
  return ROUTE_OPTIMIZATION_HOUR_INDIANA_INDIANAPOLIS - utcOffsetHours
}
const START_OF_DAY_HOUR_EST = 5

enum ROUTING_ALGORITHMS {
  ROUTE_AREA = 'route_area',
  GREEDY = 'greedy',
}

export {
  SCHEDULED_ORDER_FORMAT_TIME,
  getRouteOptimizationHourUtc,
  START_OF_DAY_HOUR_EST,
  ROUTING_ALGORITHMS,
}
